// 公共样式
// var salvProName = [];
var salvProValue = [];
var salvProMax = []; //背景按最大值
var opt = {
    index: 0
}
for (let i = 0; i < salvProValue.length; i++) {
    salvProMax.push(salvProValue[0])
}

export const echartTemp  = [
  {
    grid: {
      left: '2%',
      right: '2%',
      bottom: '0%',
      top: '5%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'none'
      },
      formatter: function(params) {
        return params[0].name + ' : ' + params[0].value
      }
    },
    xAxis: {
      show: false,
      type: 'value'
    },
    yAxis: [{
      type: 'category',
      inverse: true,
      axisLabel: {
        show: true,
        textStyle: {
          color: '#333333',
          fontSize: 13,
          fontWeight: 500
        },
        formatter: function (value, index) {
          const shortValue = value.length > 5 ? value.substring(0, 5) + '...' : value;
          console.log("shortValue==",);
          
          if (opt.index === 0 && index < 2) {
            return `{icon${index}| }  {title|${shortValue}}`; // 空格占位
          } else {
            return `{icon| }  {title|${shortValue}}`;
          }
        },
        rich: {}
      },
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: []
      // data: salvProName
    }, {
      type: 'category',
      inverse: true,
      axisTick: 'none',
      axisLine: 'none',
      show: true,
      axisLabel: {
        textStyle: {
          color: '#4B4B4B',
          fontSize: '12'
        },
        formatter: function(value) {
          return (value * 10 / 10).toLocaleString();
        },
      },
      data: []
      // data: salvProValue
    }],
    series: [{
        name: '值',
        type: 'bar',
        zlevel: 1,
        itemStyle: {
          normal: {
            barBorderRadius: 10,
            color: '#fff',
          },
        },
        barWidth: 5,
        data: []
        // data: salvProValue
      },
    ]
  },
];